if (!customElements.get('myakm-collection-layout')) {
  customElements.define('myakm-collection-layout', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.storageKey = `myakm:collection-layout:${this.dataset.collection}`;
      let view = 'grid';
      try { view = sessionStorage.getItem(this.storageKey) || view; } catch {}
      this.setView(view);
      this.querySelector('.myakm-collection-view-controls')?.removeAttribute('hidden');
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-collection-view]');
        if (!button || !this.contains(button)) return;
        this.setView(button.dataset.collectionView);
        try { sessionStorage.setItem(this.storageKey, this.dataset.view); } catch {}
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
    setView(value) {
      this.dataset.view = ['grid', 'dense', 'list'].includes(value) ? value : 'grid';
      this.querySelectorAll('[data-collection-view]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.collectionView === this.dataset.view));
      });
    }
  });
}

